<template>
  <v-card class="pa-4 mb-4">
    <v-card-title>Prenotazioni per Centri</v-card-title>
    <v-card-text style="overflow-y: auto; max-height: 600px; padding: 0;">
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-data-table
              :headers="headers"
              :items="tableData"
              hide-default-footer
              dense
              class="elevation-1 sticky-header"
              :items-per-page="100"
          >
            <template v-slot:item.center_name="{ item }">
              <template v-if="item._id">
                <a
                    :href="`/#/fields?center_id=${item._id}`"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  {{item.center_name}}
                </a>
              </template>
              <template v-else>
                {{item.center_name}}
              </template>
            </template>
            <template v-slot:item.total="{ item }">
              <strong>{{ item.total }}</strong>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TopCenters',
  props: {
    filters: Object,
    centers: Array
  },
  data() {
    return {
      centersMap: {},
      rawData: [],
      headers: [
        { text: 'Centro', value: 'center_name' },
        { text: 'Tot.', value: 'total', align: 'right' }
      ],
    };
  },
  computed: {
    tableData() {
      return this.rawData.map(r => {
        const name = this.centersMap[r._id.toString()] || `ID ${r._id}`;
        return { center_name: name, total: r.total, _id: r._id };
      }).sort((a, b) => b.total - a.total);
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    },
    centers: {
      deep: true,
      immediate: true,
      handler() {
        this.buildCenterMap();
      }
    }
  },
  methods: {
    buildCenterMap() {
      this.centersMap = {};
      for (const c of this.centers) {
        this.centersMap[c._id.toString()] = c.desc;
      }
    },
    async fetchData(filters) {
      this.rawData = await this.$store.dispatch('analytics/getReservationsByCenter', filters);
    }
  }
};
</script>
<style scoped>
.sticky-header thead th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}
</style>